/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
import { createUseGlobalVariants } from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantspb5CqIuw6D1V } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: pb5CqIUW6d1V/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantspb5CqIuw6D1V
});
